import React, { useMemo, useState } from "react";
import {
  AppPage,
  MimaButton,
  MimaNewFilter,
  MimaOptionMenu,
  MimaTable,
} from "../../../components";
import constant from "../../../utils/constant";
import moment from "moment";
import { amountFormatter } from "../../../utils/utils";
import { AnimatePresence } from "framer-motion";
import {
  ViewMoreAdsContainer,
  CreateAdContainer,
  EditAdContainer,
} from "../../../containers";

const MoneyExAds = ({
  onLimitChange,
  data,
  currentPage,
  setCurrentPage,
  limit,
  isLoading,
  isFetching,
  setSearchQuery,
  viewMoreAdsModal,
  setViewMoreAdsModal,
  closeModal,
  createAdsModal,
  goToCreateAdsModal,
  filterHandler,
  goToEditAdsModal,
  editAdsModal,
}) => {
  const [item, setItem] = useState({});
  const [showFilter, setShowFilter] = useState(false);

  const filterByData = [
    { value: "To Currency", key: "to" },
    { value: "From Currency", key: "from" },
  ];

  const moneyExAdsTableData = useMemo(() => {
    if (data?.status === constant.Success) {
      return data?.data?.moneyExAds || [];
    }
    return [];
  }, [data]);

  const moneyExAdsTableColumns = [
    {
      Header: "Date",
      accessor: "createdAt",
      Cell: ({ cell }) => {
        const date = cell.row.original.createdAt;
        return <span>{moment(date).format("DD/MM/YYYY")}</span>;
      },
    },
    {
      Header: "User Name",
      Cell: ({ cell }) => {
        const userName = cell.row.original.moneyExUser.username;
        return <span>{userName}</span>;
      },
    },
    {
      Header: "Available Amount",
      Cell: ({ cell }) => {
        const amount = cell.row.original.availableAmount;
        const currencyCode = cell.row.original.from;
        return <span>{amountFormatter(currencyCode).format(amount)}</span>;
      },
    },
    {
      Header: "Min Per Sale",
      Cell: ({ cell }) => {
        const minPerSale = cell.row.original.minPerSale;
        const currencyCode = cell.row.original.from;
        return <span>{amountFormatter(currencyCode).format(minPerSale)}</span>;
      },
    },
    {
      Header: "Rate",
      accessor: "rate",
    },
    {
      Header: "From",
      accessor: "from",
    },
    {
      Header: "To",
      accessor: "to",
    },
    {
      Header: "Is Admin",
      Cell: ({ cell }) => {
        const isAdmin = cell.row.original.isAdmin;
        return <span>{isAdmin ? "Yes" : "No"}</span>;
      },
    },
    {
      Header: "Actions",
      Cell: ({ cell }) => {
        const item = cell.row.original;
        const isAdmin = item.isAdmin;
        return (
          <MimaOptionMenu
            options={[
              { label: "View Bank Info", value: "View Bank Info" },
              !isAdmin ? { label: "Edit Ad", value: "Edit Ad" } : "",
            ]}
            onOptionSelected={(option) => {
              setItem(item);
              if (option.value === "View Bank Info") {
                setViewMoreAdsModal(true);
              } else if (option.value === "Edit Ad") {
                goToEditAdsModal();
              }
            }}
          />
        );
      },
    },
    // {
    //   Header: "Actions",
    //   Cell: ({ cell }) => {
    //     const item = cell.row.original;
    //     return (
    //       <span
    //         className="tableAction__text"
    //         onClick={() => {
    //           setItem(item);
    //           setViewMoreAdsModal(true);
    //         }}
    //       >
    //         View Bank Info
    //       </span>
    //     );
    //   },
    // },
  ];
  return (
    <AppPage pageTitle="Money-Ex Ads">
      <div style={{ display: "flex", justifyContent: "space-between" }}>
        <MimaButton
          title={showFilter ? "Close Filter" : "Filter"}
          onClick={() => setShowFilter(!showFilter)}
        />
        <MimaButton
          // buttonColor="var(--color-white)"
          // variant="outlined"
          title="Create Ad"
          onClick={goToCreateAdsModal}
        />
      </div>
      <MimaNewFilter
        showFilter={showFilter}
        setShowFilter={setShowFilter}
        filterByData={filterByData}
        filterHandler={filterHandler}
      />
      <MimaTable
        tableData={moneyExAdsTableData}
        tableColumns={moneyExAdsTableColumns}
        searchPlaceholder="Search Money-Ex Adds"
        searchVariant="wide"
        totalItems={data?.data?.totalCounts}
        onLimitChange={onLimitChange}
        isLoading={isLoading}
        isFetching={isFetching}
        limit={limit}
        currentPage={currentPage}
        setCurrentPage={setCurrentPage}
        setSearchQuery={setSearchQuery}
      />
      {(viewMoreAdsModal || createAdsModal || editAdsModal) && (
        <div className="modal">
          <AnimatePresence>
            {viewMoreAdsModal && (
              <ViewMoreAdsContainer closeModal={closeModal} item={item} />
            )}
            {createAdsModal && <CreateAdContainer closeModal={closeModal} />}
            {editAdsModal && (
              <EditAdContainer closeModal={closeModal} item={item} />
            )}
          </AnimatePresence>
        </div>
      )}
    </AppPage>
  );
};

export default MoneyExAds;
